import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * External dependencies
 */
import { AnimatePresence, motion } from 'framer-motion';
import { useContext, useEffect, useState } from 'react';
import useWindowDimensions from '../hooks/useWindowDimensions';
import { SET_ACCESSIBILITY, SET_CATEGORIES, SET_DATES, SET_FILTERED_POSTS, SET_KEYWORD, SET_ORDER, SET_REGIONS, store } from '../state/state';
import Button from './Button';
import FiltersDropdown from './FiltersDropdown';
import Icon from './Icon';
import MapToggle from './MapToggle';
const params = new URLSearchParams(window.location.search);
const keyword = params.get('keyword') ? params.get('keyword') : '';
const category = params.get('category') ? params.get('category') : '';
const region = params.get('region') ? params.get('region') : '';
const eventDate = params.get('eventDate') ? params.get('eventDate') : '';
const Filters = ({ accessibility, categories, date, map, postType, regions, search, searchPlaceholder, sort, title }) => {
    const { width } = useWindowDimensions();
    const isTablet = width >= 768;
    const globalState = useContext(store);
    const { state, dispatch } = globalState;
    const [expanded, setExpanded] = useState(isTablet);
    const [searchValue, setSearchValue] = useState(state.search || '');
    useEffect(() => {
        dispatch({
            type: SET_KEYWORD,
            keyword: keyword ? keyword : ''
        });
        setSearchValue(keyword ? keyword : '');
        if (category) {
            dispatch({
                type: SET_CATEGORIES,
                categories: category.split(',')
            });
            dispatch({
                type: SET_FILTERED_POSTS,
                ...state,
                categories: category.split(',')
            });
        }
        if (eventDate) {
            dispatch({
                type: SET_DATES,
                dates: [eventDate]
            });
            dispatch({
                type: SET_FILTERED_POSTS,
                ...state,
                dates: [eventDate]
            });
        }
        if (region) {
            dispatch({
                type: SET_REGIONS,
                regions: [region]
            });
            dispatch({
                type: SET_FILTERED_POSTS,
                ...state,
                regions: [region]
            });
        }
        if (date || (postType === 'post' || postType === 'news')) {
            dispatch({
                type: SET_ORDER,
                order: 'date'
            });
            dispatch({
                type: SET_FILTERED_POSTS,
                ...state,
                order: 'date'
            });
        }
    }, []);
    useEffect(() => {
        if (isTablet) {
            setExpanded(true);
        }
    }, [expanded, isTablet]);
    const onFocus = (e) => {
        e.target.parentElement.classList.add('is-focused');
    };
    const onBlur = (e) => {
        if (e.target.value == '') {
            e.target.parentElement.classList.remove('has-value');
            e.target.parentElement.classList.remove('is-focused');
        }
        else {
            e.target.parentElement.classList.remove('is-focused');
            e.target.parentElement.classList.add('has-value');
        }
    };
    const handleChange = (e, actionMeta) => {
        console.log('change', e);
        let values;
        switch (actionMeta.name) {
            case 'accessibility':
                dispatch({
                    type: SET_ACCESSIBILITY,
                    accessibility: inputValues(e)
                });
                values = inputValues(e);
                break;
            case 'categories':
                dispatch({
                    type: SET_CATEGORIES,
                    categories: inputValues(e)
                });
                values = inputValues(e);
                break;
            case 'date':
                dispatch({
                    type: SET_DATES,
                    dates: inputValues(e)
                });
                values = inputValues(e);
                break;
            case 'regions':
                dispatch({
                    type: SET_REGIONS,
                    regions: inputValues(e)
                });
                values = inputValues(e);
                break;
            case 'order':
                dispatch({
                    type: SET_ORDER,
                    order: e.value
                });
                values = e.value;
                break;
        }
        dispatch({
            type: SET_FILTERED_POSTS,
            ...state,
            [actionMeta.name]: values
        });
    };
    const handleSearchChange = (e) => {
        const value = e.target.value.toString();
        if (e.target.value.length > 3) {
            dispatch({
                type: SET_KEYWORD,
                keyword: value
            });
            dispatch({
                type: SET_FILTERED_POSTS,
                ...state,
                keyword: value
            });
        }
        else {
            dispatch({
                type: SET_KEYWORD,
                keyword: ''
            });
        }
        setSearchValue(value);
    };
    const defaultValues = (arr, arr2) => {
        return arr.reduce((acc, item) => {
            if (arr2.includes(item.value)) {
                acc.push(item);
            }
            return acc;
        }, []);
    };
    const inputValues = ((arr, field = 'value') => {
        return arr.reduce((acc, item) => {
            for (const key in item) {
                if (item[key] !== null && key === field) {
                    acc.push(item[key]);
                }
            }
            return acc;
        }, []);
    });
    const clearSearch = () => {
        dispatch({
            type: SET_KEYWORD,
            keyword: ''
        });
        dispatch({
            type: SET_FILTERED_POSTS,
            ...state,
            keyword: ''
        });
        setSearchValue('');
    };
    return (_jsxs("section", { className: "post-filters corridor space-y-10 tablet-landscape:space-y-12", children: [search && _jsxs("div", { className: `relative${searchValue.length > 3 ? ' has-value' : ''}`, children: [searchPlaceholder &&
                        _jsx("label", { htmlFor: "keyword", className: "hidden", children: searchPlaceholder }), _jsx("input", { id: "keyword", name: "keyword", type: "text", value: searchValue, onFocus: onFocus, onBlur: onBlur, onChange: handleSearchChange, placeholder: searchPlaceholder ? searchPlaceholder : '', className: "text-input h3" }), _jsx("div", { className: "absolute w-6 h-6 text-gold top-1/2 right-3.5 -translate-y-1/2 tablet-landscape:right-0 tablet-landscape:w-10 tablet-landscape:h-10", children: searchValue === '' ? (_jsx(Icon, { name: "search" })) : (_jsx("button", { className: "w-full h-full", onClick: () => clearSearch(), children: _jsx(Icon, { name: "close" }) })) })] }), _jsxs("div", { className: "flex flex-wrap items-center justify-between pb-6 border-b border-grey-100 tablet-portrait:items-center tablet-landscape:pb-0 tablet-landscape:border-0", children: [_jsxs("div", { className: "relative flex items-center space-x-2 tablet-portrait:hidden", children: [_jsx(Button, { height: "!h-10", onClick: () => setExpanded(!expanded), children: "Filters" }), state.filtersLength > 0 && (_jsx("div", { className: "flex items-center justify-center w-6 h-6 font-semibold leading-none text-white rounded-full text-body-small bg-green", children: state.filtersLength }))] }), title && _jsx("p", { className: "font-semibold leading-tighter", children: title }), _jsxs("div", { className: "tablet-portrait:order-2 tablet-portrait:flex tablet-portrait:items-center tablet-portrait:space-x-8", children: [date && sort && state.posts.length > 12 && _jsxs("div", { className: "hidden tablet-portrait:flex tablet-portrait:items-center tablet-portrait:space-x-1", children: [_jsx("p", { className: "font-semibold leading-tighter text-grey-300", children: "Sort by" }), _jsx(FiltersDropdown, { options: JSON.parse(sort), onChange: handleChange, name: "order", defaultValue: date ? {
                                            value: 'date',
                                            label: 'Date'
                                        } : { value: 'title', label: 'Title (A-Z)' } })] }), map && _jsx(MapToggle, {})] }), _jsx(AnimatePresence, { initial: false, children: expanded && (_jsxs(motion.div, { initial: "collapsed", animate: "open", exit: "collapsed", variants: {
                                open: { opacity: 1, height: 'auto' },
                                collapsed: { opacity: 0, height: 0 }
                            }, transition: { duration: 0.25, ease: [0.04, 0.62, 0.23, 0.98] }, className: `flex flex-col w-full space-y-6 transition-all duration-300 pt-6 tablet-portrait:pt-0 tablet-portrait:w-auto tablet-portrait:order-1 tablet-portrait:space-y-0 tablet-portrait:space-x-8 tablet-portrait:items-center tablet-portrait:flex-row`, children: [regions &&
                                    _jsx("span", { className: "regions-filter", children: _jsx(FiltersDropdown, { options: JSON.parse(regions), placeholder: "Location", onChange: handleChange, defaultValue: defaultValues(JSON.parse(regions), region ? region.split(',') : []), name: "regions", isMulti: true }) }), accessibility &&
                                    _jsx(FiltersDropdown, { options: JSON.parse(accessibility), placeholder: "Accessibility", onChange: handleChange, name: "accessibility", isMulti: true }), categories &&
                                    _jsx(FiltersDropdown, { options: JSON.parse(categories), 
                                        // defaultValue={JSON.parse(categories)[indexOf(JSON.parse(categories), category)]}
                                        defaultValue: defaultValues(JSON.parse(categories), category ? category.split(',') : []), placeholder: "Type", onChange: handleChange, name: "categories", isMulti: true }), date &&
                                    _jsx("span", { className: "event-date", children: _jsx(FiltersDropdown, { options: JSON.parse(date), placeholder: "Date", onChange: handleChange, defaultValue: defaultValues(JSON.parse(date), eventDate ? eventDate.split(',') : []), name: "date", isMulti: true }) }), date && sort && _jsxs("div", { className: "flex items-center space-x-1 tablet-portrait:hidden", children: [_jsx("p", { className: "font-semibold leading-tighter text-grey-300", children: "Sort by" }), _jsx(FiltersDropdown, { options: JSON.parse(sort), onChange: handleChange, name: "order", defaultValue: date ? {
                                                value: 'date',
                                                label: 'Date'
                                            } : { value: 'title', label: 'Title (A-Z)' } })] })] }, "content")) })] })] }));
};
export default Filters;
